<div class="bottomsheet-wrapper">
  <div 
  class="header"
  (click)="closeBottomsheet()"
  >
    <div class="text-container">
      <mat-icon svgIcon="unh_config"></mat-icon>
      <span class="title">OPÇÕES</span>
    </div>
    <a 
    class="btn-close"
    (click)="closeBottomsheet()">
        <mat-icon svgIcon="unh_forum_manager_close"></mat-icon>
      <!-- <img class="times-ico" src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/svg-icons/forum/bottomsheet-manager/bottomsheet-close.svg" alt="Close modal" (click)="closeModal()"> -->
    </a>
  </div>
  <div class="content-wrapper">
    <ul>
      <li *ngFor="let item of items" (click)="item.options?.highlight ? unHighilghtItem(item) : selectOption(item)">

        <div class="item-wrapper">
          <div *ngIf="item.icon" class="item-icon" [class.pinned]="item?.options?.highlight">
            <mat-icon svgIcon="{{item.icon}}"></mat-icon>
          </div>
          <span class="item-title">{{item.name}}</span>
        </div>
      </li>
    </ul>
  </div>
</div>
